import { Component, FC } from 'react';
import { LAYOUT } from './layout';

export interface IRoute {
  path: string;
  redirect?: string;
  Component?: FC | typeof Component;
  protected?: boolean;
  layout?: LAYOUT;
  title?: string;
  subtitle?: string;
  exact?: boolean;
  group?: string;
  inNav?: boolean; // assume true unless specified
  titleNav?: string;
}

export interface IRouteNormalized extends IRoute {
  titleNav: string;
}

export interface IRouteGroup {
  group: string;
  routes: IRouteNormalized[];
}
